// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Comment.scss';
import MatchButton from './MatchButton/MatchButton';
import TimeAgo from '../Util/TimeAgo/TimeAgo';

@observer class Comment extends Component<any, any> {
	render() {
		return (
			<div className="comment">
				<div className="comment-header">
					{this.props.match ?
						(<MatchButton className="match-button" onClick={(e: any) => {e.preventDefault(); this.props.match(e, this.props.comment.id)}} text='match' />)
						:
						null
					}
					<p><b>{this.props.comment.user.username}</b> <TimeAgo date={this.props.comment.created_at}/></p>
				</div>
				<div className="comment-body">
					<p>{this.props.comment.content.replace(/\n\s*\n\s*\n/g, '\n\n')}</p>
				</div>
			</div>
		)
	}
}

export default Comment;

